// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const SUGEST_STATUS = {
  Pendente: 'SUGEST_STATUS1',
  EmAnalise: 'SUGEST_STATUS2',
  Planejado: 'SUGEST_STATUS3',
  EmDesenvolvimento: 'SUGEST_STATUS4',
  Concluido: 'SUGEST_STATUS5',
  Rejeitado: 'SUGEST_STATUS6',
  Rascunho: 'SUGEST_STATUS7',
  Banido: 'SUGEST_STATUS8',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    SUGEST_STATUS1: 1,
    SUGEST_STATUS2: 2,
    SUGEST_STATUS3: 3,
    SUGEST_STATUS4: 4,
    SUGEST_STATUS5: 5,
    SUGEST_STATUS6: 6,
    SUGEST_STATUS7: 7,
    SUGEST_STATUS8: 8
  }
}
